<template>
  <div style="padding:100px 8%;">
    <div>
      <h4>資料庫匯率列表</h4>
      <section class="row"   :class="{'section-loading': isLoading}">
        <table class="table datatable">
          <thead>
            <tr>
              <th style="width:35%" class="text-center">基礎幣別</th>
              <th style="width:35%" class="text-center">目標幣別</th>
              <th style="width:30%" class="text-center">匯率</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, i) in rateList" :key="`tradition-data-${i}`">
              <td>{{data.baseCurrency}}</td>
              <td>{{data.targetCurrency}}</td>
              <td>{{data.rate}}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>
  </div>
</template>

<script>
import { getExchangeRate } from "@/service";
export default {
  name: "ExchangeRateList",
  mixins: [],
  data() {
    return {
      rateList: [],
      currency: {
        JPY: "日幣",
        ZAR: "南非幣",
        NZD: "紐幣",
        NTD: "新台幣",
        TWD: "新台幣",
        HKD: "港幣",
        GBP: "英鎊",
        EUR: "歐元",
        CNY: "人民幣",
        AUD: "澳幣",
        USD: "美元",
      },
      isLoading: false
    };
  },
  methods: {
    async init() {
      this.isLoading = true;
      getExchangeRate(this.$store.state.userInfo.id).then((result) => {
        if (result.header && result.header.status == "200") {
          result.data.forEach((item) => {
            let rateData = {
              baseCurrency: this.getCurrencyName(item.money_code_curr),
              targetCurrency: this.getCurrencyName(item.money_code_fori),
              rate: item.payment,
            };
            this.rateList.push(rateData);
          });
        } else {
          this.$toast.info({ title: result.header.message });
        }
        this.isLoading = false;
      });
    },
    getCurrencyName(cur) {
      return this.currency[cur] + "(" + cur + ")";
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped>
.mt-40 {
  margin-top: 40px;
}

.ml-40 {
  margin-left: 40px;
}
</style>
